"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiPermissionsType = exports.TerritoryRestrictionsType = void 0;
var TerritoryRestrictionsType;
(function (TerritoryRestrictionsType) {
    TerritoryRestrictionsType["RESTRICTED"] = "RESTRICTED";
    TerritoryRestrictionsType["NO_RESTRICTIONS"] = "NO_RESTRICTIONS";
})(TerritoryRestrictionsType || (exports.TerritoryRestrictionsType = TerritoryRestrictionsType = {}));
var AiPermissionsType;
(function (AiPermissionsType) {
    AiPermissionsType["ALLOWED"] = "ALLOWED";
    AiPermissionsType["ALLOWED_WITH_RESTRICTIONS"] = "ALLOWED_WITH_RESTRICTIONS";
    AiPermissionsType["NOT_ALLOWED"] = "NOT_ALLOWED";
})(AiPermissionsType || (exports.AiPermissionsType = AiPermissionsType = {}));
//# sourceMappingURL=Contract.js.map